/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SpecTemplateParagraphIs, SpecTemplateTextIs } from '@gh/builder-shared-data';
import {
  AbstractSnapshotFormComponent,
  EnumDictionary,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
  getRouteInitData,
  whenCreateOrEditMode,
} from '@gh/common-shared';
import { assign } from 'lodash';
import { JstParagraphInfo } from '../../../resources/job-spec-template.model';

@Component({
  standalone: false,
  selector: 'gh-jst-paragraph-form',
  styleUrls: ['jst-paragraph-form.component.scss'],
  templateUrl: 'jst-paragraph-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JstParagraphFormComponent extends AbstractSnapshotFormComponent<JstParagraphInfo> implements OnInit {
  paragraphIsDict: EnumDictionary<SpecTemplateParagraphIs>;
  textIsDict: EnumDictionary<SpecTemplateTextIs>;

  constructor(private route: ActivatedRoute,
              private formStateBuilder: FormStateBuilder) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    assign(this, getRouteInitData(this.route));
  }

  protected buildForm(snapshot: FormStateSnapshot<JstParagraphInfo>): FormState<JstParagraphInfo> {
    return this.formStateBuilder.buildPlain({
      mode: this.mode,
      enabled: whenCreateOrEditMode(),
      snapshot,
      children: {
        paragraphIs: { required: true },
        name: { required: true },
        textIs: { required: true },
        text: void 0,
        isTextWarning: void 0,
      },
    });
  }
}
